import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import DialogContent from "@material-ui/core/DialogContent";
import Input from "Components/Input/Input";
import Grid from "@material-ui/core/Grid";
import { useTranslation } from 'react-i18next';
import Translator from "Languages/Utility/Translator";
import * as R from "ramda";
import MuiButton from "Components/MuiButton/MuiButton";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import { changeKhadamtSearch, GetAllKhedmat, GetKhedmatSys, InsertKhedmatData } from "Stores/actions/properties/UtilityAction";
import { read } from "Helpers/LocalStorage";
import MuiSkeleton from "Components/MuiSkeleton/MuiSkeleton";
import showNotify from "Helpers/Notify";
import {DialogActions} from "@material-ui/core";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";

function InsertKhedmat() {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const { khedmatSys } = useSelector((state) => ({
    khedmatSys: state.khedmat.khedmatSys
  }));
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [loading, setLoading] = useState(false);
  const [checkValid, setCheckValid] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const { khedmatDataPagination } = useSelector((state) => ({
    khedmatDataPagination: state.khedmat.khedmatDataPagination,
  }));
  const [controls, setControls] = useSetState({
    calculationType : {
      type: "select",
      selectItems: [],
      value: "",
      validation: {
        required: true,
      },
    },
    titleService: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
    },
    priceService: {
      type: "price",
      value: "0",
      validation: {
        required: true,
        isPrice: true,
        notZero: true,
      },
    },
  });

  useEffect(() => {
    setControls({ calculationType: { value: khedmatSys[0] } });
    setControls({ calculationType: { selectItems: khedmatSys } });
  }, [khedmatSys]);

  const onFinish = async (e) => {
    e.preventDefault();
    const { titleService, calculationType, priceService } = controls;
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      setLoading(true);
      try {
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Price: +priceService.value,
          Name: titleService.value,
          IdSys: +calculationType.value.Id,
        };
        await dispatch(InsertKhedmatData(data));
        dispatch(changeKhadamtSearch({ Name: "" }));
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Limit: khedmatDataPagination.Limit,
          Page: 1,
        };
        await dispatch(GetAllKhedmat(params));
        handleDialog();
        onClear();
        setLoading(false);
      } catch (e) {
        showNotify({
          text: t('correctFormDataRequired'),
          customClass: "error",
        });
      }
      handleDialog();
    } else {
      setCheckValid(true);
    }
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
  };

  const handleDialog = () => {
    setOpenDialog(!openDialog);
  };

  const onEnter = async () => {
    onClear();
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
      };
      await dispatch(GetKhedmatSys(params));
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const onClear = () => {
    setFormValid({ titleService: false, priceService: false });
    setCheckValid(false);
    setControls({ calculationType: { value: "" } });
    setControls({ titleService: { value: "" } });
    setControls({ priceService: { value: "0" } });
  };

  return (
    <>
      <BackDropLoading loading={loading}/>
      <MuiButton
        loading={loading}
        color="primary"
        title={<Translator id={"newService"}/>}
        onClick={handleDialog}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="xs"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>{<Translator id={"addNewService"}/>}</p>
          </div>
          <DialogContent>
            {!loading ? (
              <Grid container spacing={2} className="d-flex">
                {
                  Object.keys(controls).map((key, index) => {
                    return (
                      <Grid item key={key + index} xs={12} style={{marginBottom: controls[key].type === "select" ? '20px' : '0px'}}>
                        {
                          controls[key].type === "select" &&
                          <MuiAutoComplete
                            loading={loading}
                            options={controls[key].selectItems}
                            label={<Translator id={key} />}
                            value={controls[key].value}
                            id={key}
                            onChange={autoCompleteHandler}
                          />
                        }
                        {
                          controls[key].type === "text" &&
                          <Input
                            setValue={setValue.bind(this)}
                            name={key}
                            placeholder={t(key)}
                            validation={controls[key].validation}
                            label={<Translator id={key} />}
                            type="text"
                            checkValid={checkValid}
                            value={controls[key].value}
                          />
                        }
                        {
                          controls[key].type === "price" &&
                          <Input
                            setValue={setValue.bind(this)}
                            value={controls[key].value}
                            name={key}
                            placeholder={t(key)}
                            validation={controls[key].validation}
                            checkValid={checkValid}
                            type={controls[key].type}
                            label={<Translator id={key} />}
                            endIcon={<Translator id='moneyUnit' />}
                          />
                        }
                      </Grid>
                    );
                  }
                )}
              </Grid>
            ) : (
              <MuiSkeleton xs={12} number={3}/>
            )}
          </DialogContent>
          <DialogActions>
            <MuiButton
                color="primary"
                type="submit"
                title={<Translator id="button_save" />}
            />
            <MuiButton
                onClick={handleDialog}
                title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default InsertKhedmat;
